import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue2Editor from "vue2-editor";
import firebase from "firebase/app";
import "firebase/auth";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueGeolocation from "vue-browser-geolocation";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(Vue2Editor);
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
  load: {
    key: "",
  },
});

Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});

Vue.use(Toast, {
  // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left.
  position: "top-right",

  // place newest toast on the top
  newestOnTop: true,

  // the max number of toasts (was 20)
  maxToasts: 2,

  // name of the Vue Transition or object with classes to use
  // only enter-active, leave-active and move are applied.
  transition: "Vue-Toastification__bounce",

  // duration in ms
  // or an object: {enter: Number, leave: Number}
  transitionDuration: 750,

  // allows to dismiss by drag & swipe events
  draggable: true,
  draggablePercent: 0.6,

  // auto pause when out of focus
  pauseOnFocusLoss: true,

  // auto pause on hover
  pauseOnHover: true,

  // close on click
  closeOnClick: true,

  // auto dismiss after this timeout
  timeout: 5000,

  // container element
  container: document.body,

  // custom classes
  toastClassName: [],

  // body classes
  bodyClassName: [],

  // show/hide the progress bar
  hideProgressBar: false,

  // show/hide the close button
  hideCloseButton: false,

  // custom icons here
  icon: true,
});
